import { Icon } from '@iconify/react';
import React, { useState, useEffect } from 'react';
import { pageTitle } from '../../helper';
import Div from '../Div';
import PageHeading from '../PageHeading';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import ContactInfoWidget from '../Widget/ContactInfoWidget';

export default function ContactPage() {
  pageTitle('Contact Us');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // State to store form values
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    projectType: '',
    mobile: '',
    message: '',
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Submit form to Make.com Webhook
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);
    setError(false);

    try {
      const webhookUrl = 'https://hook.eu2.make.com/2h4elj8tp6t639iiubgweod9mldy4e5l'; // Replace with your actual Make.com Webhook URL

      const payload = {
        fullName: formData.fullName,
        email: formData.email,
        projectType: formData.projectType,
        mobile: formData.mobile,
        message: formData.message,
      };

      const response = await fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload), // Ensure it sends a structured JSON object
      });

      if (response.ok) {
        setSuccess(true);
        setFormData({ fullName: '', email: '', projectType: '', mobile: '', message: '' });
      } else {
        setError(true);
      }
    } catch (err) {
      console.error('Error submitting form:', err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };


  return (
      <>
        <PageHeading
            title="Contact Us"
            bgSrc="/images/contact_hero_bg.jpeg"
            pageLinkText="Contact"
        />
        <Spacing lg="150" md="80" />
        <Div className="container">
          <Div className="row">
            <Div className="col-lg-6">
              <SectionHeading
                  title="Do you have a project <br/>in your mind?"
                  subtitle="Get in Touch"
              />
              <Spacing lg="55" md="30" />
              <ContactInfoWidget withIcon />
              <Spacing lg="0" md="50" />
            </Div>
            <Div className="col-lg-6">
              <form className="row" onSubmit={handleSubmit}>
                <Div className="col-sm-6">
                  <label className="cs-primary_color">Full Name*</label>
                  <input type="text" name="fullName" value={formData.fullName} onChange={handleChange} className="cs-form_field" required />
                  <Spacing lg="20" md="20" />
                </Div>
                <Div className="col-sm-6">
                  <label className="cs-primary_color">Email*</label>
                  <input type="email" name="email" value={formData.email} onChange={handleChange} className="cs-form_field" required />
                  <Spacing lg="20" md="20" />
                </Div>
                <Div className="col-sm-6">
                  <label className="cs-primary_color">Project Type*</label>
                  <input type="text" name="projectType" value={formData.projectType} onChange={handleChange} className="cs-form_field" required />
                  <Spacing lg="20" md="20" />
                </Div>
                <Div className="col-sm-6">
                  <label className="cs-primary_color">Mobile*</label>
                  <input type="tel" name="mobile" value={formData.mobile} onChange={handleChange} className="cs-form_field" required />
                  <Spacing lg="20" md="20" />
                </Div>
                <Div className="col-sm-12">
                  <label className="cs-primary_color">Message*</label>
                  <textarea name="message" cols="30" rows="7" value={formData.message} onChange={handleChange} className="cs-form_field" required></textarea>
                  <Spacing lg="25" md="25" />
                </Div>
                <Div className="col-sm-12">
                  <button type="submit" className="cs-btn cs-style1" disabled={loading}>
                    {loading ? 'Sending...' : <><span>Send Message</span> <Icon icon="bi:arrow-right" /></>}
                  </button>
                  {success && <p className="cs-success_message">✅ Message sent successfully!</p>}
                  {error && <p className="cs-error_message">❌ Something went wrong. Please try again.</p>}
                </Div>
              </form>
            </Div>
          </Div>
        </Div>
        <Spacing lg="150" md="80" />
      </>
  );
}
